export default "__VITE_ASSET__C8BbQ6J0__"